// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"68":"ab5c19f1","118":"7e74164d","895":"6ececdc1","957":"e9ad0366"}[chunkId] + ".chunk.js";
};